import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Textarea } from "../../components/ui/textarea";
import { Label } from "../../components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { ImageField } from "./ContentManager";

const groups = [
  {
    key: "menu",
    title: "Nama Menu",
    fields: [
      { key: "menu_beranda", label: "Menu: Beranda", type: "text" },
      { key: "menu_profil", label: "Menu: Profil", type: "text" },
      { key: "menu_bidang", label: "Menu: Bidang PB", type: "text" },
      { key: "menu_informasi", label: "Menu: Info Kebencanaan", type: "text" },
      { key: "menu_informasi_publik", label: "Menu: Informasi Publik", type: "text" },
      { key: "menu_produk_hukum", label: "Menu: Produk Hukum", type: "text" },
      { key: "menu_layanan", label: "Menu: Layanan", type: "text" },
      { key: "menu_berita", label: "Menu: Berita", type: "text" },
      { key: "menu_kegiatan", label: "Menu: Kegiatan", type: "text" },
      { key: "menu_galeri", label: "Menu: Galeri", type: "text" },
      { key: "menu_faq", label: "Menu: FAQ", type: "text" },
      { key: "menu_lapor", label: "Tombol: Lapor Bencana", type: "text" },
    ],
  },
  {
    key: "beranda",
    title: "Beranda",
    fields: [
      { key: "hero_foto", label: "Foto Besar Beranda (hero)", type: "image" },
    ],
  },
  {
    key: "profil",
    title: "Profil",
    fields: [
      { key: "profil_foto", label: "Foto Halaman Profil (kantor BPBD)", type: "image" },
      { key: "profil_sejarah", label: "Sejarah Pembentukan (pisahkan paragraf dengan baris kosong)", type: "textarea", rows: 6 },
      { key: "profil_visi", label: "Visi", type: "textarea", rows: 2 },
      { key: "profil_misi", label: "Misi (satu poin per baris)", type: "textarea", rows: 4 },
      { key: "profil_dasar_hukum", label: "Dasar Hukum (satu poin per baris)", type: "textarea", rows: 5 },
      { key: "profil_tupoksi", label: "Tugas Pokok & Fungsi (satu poin per baris)", type: "textarea", rows: 6 },
    ],
  },
  {
    key: "bidang",
    title: "Bidang PB",
    fields: [
      { key: "bidang_pencegahan", label: "Pencegahan & Kesiapsiagaan (satu poin per baris)", type: "textarea", rows: 5 },
      { key: "bidang_kedaruratan", label: "Penanganan Kedaruratan (satu poin per baris)", type: "textarea", rows: 5 },
      { key: "bidang_rehabilitasi", label: "Rehabilitasi & Rekonstruksi (satu poin per baris)", type: "textarea", rows: 5 },
      { key: "bidang_trc", label: "Uraian Tim Reaksi Cepat (TRC)", type: "textarea", rows: 4 },
    ],
  },
  {
    key: "layanan",
    title: "Layanan",
    fields: [
      { key: "layanan_cara_lapor", label: "Cara Melaporkan Bencana (satu langkah per baris)", type: "textarea", rows: 5 },
      { key: "layanan_sebelum", label: "Tips Sebelum Bencana (satu poin per baris)", type: "textarea", rows: 5 },
      { key: "layanan_saat", label: "Tips Saat Bencana (satu poin per baris)", type: "textarea", rows: 5 },
      { key: "layanan_sesudah", label: "Tips Sesudah Bencana (satu poin per baris)", type: "textarea", rows: 5 },
      { key: "layanan_mitra", label: "Mitra Kerja (uraian)", type: "textarea", rows: 3 },
      { key: "layanan_partisipasi", label: "Cara Berpartisipasi (uraian)", type: "textarea", rows: 3 },
      { key: "layanan_bantuan", label: "Penerimaan Bantuan (uraian)", type: "textarea", rows: 3 },
    ],
  },
  {
    key: "infopublik",
    title: "Informasi Publik",
    fields: [
      { key: "infopublik_daftar", label: "Daftar Informasi Publik (satu poin per baris)", type: "textarea", rows: 4 },
      { key: "infopublik_perencanaan", label: "Perencanaan & Kinerja (satu poin per baris)", type: "textarea", rows: 5 },
      { key: "infopublik_peraturan", label: "Peraturan Terkait (satu poin per baris)", type: "textarea", rows: 5 },
      { key: "ppid_mekanisme", label: "Mekanisme Permohonan Informasi (satu langkah per baris)", type: "textarea", rows: 6 },
      { key: "ppid_uraian", label: "Uraian PPID", type: "textarea", rows: 4 },
    ],
  },
  {
    key: "kontak",
    title: "Kontak & PPID",
    fields: [
      { key: "kontak_darurat", label: "Nomor Telepon Darurat / Call Center (bawaan: 112)", type: "text" },
      { key: "notif_emails", label: "Email Penerima Notifikasi Laporan Baru (pisahkan dengan koma)", type: "text" },
      { key: "kontak_alamat", label: "Alamat Kantor", type: "text" },
      { key: "kontak_telepon", label: "Telepon Posko / Layanan", type: "text" },
      { key: "kontak_email", label: "Email", type: "text" },
      { key: "kontak_jam", label: "Jam Operasional", type: "text" },
      { key: "ppid_email", label: "Email PPID", type: "text" },
      { key: "ppid_jadwal", label: "Jadwal Layanan PPID", type: "text" },
      { key: "ppid_tanggapan", label: "Waktu Tanggapan PPID", type: "text" },
    ],
  },
];

export const SiteSettings = () => {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content").then((r) => setForm(r.data || {})).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content", { values: form });
      toast.success("Pengaturan situs disimpan — perubahan langsung tampil di situs");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-3xl" data-testid="site-settings-panel">
      <p className="text-sm text-slate-500 mb-6">
        Seluruh teks halaman publik dikelola di sini, dikelompokkan per halaman. Kosongkan isian untuk memakai teks bawaan (situs tidak pernah kosong).
      </p>
      <Tabs defaultValue="beranda">
        <TabsList className="flex-wrap h-auto">
          {groups.map((g) => (
            <TabsTrigger key={g.key} value={g.key} data-testid={`settings-tab-${g.key}`}>{g.title}</TabsTrigger>
          ))}
        </TabsList>
        {groups.map((g) => (
          <TabsContent key={g.key} value={g.key}>
            <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-4">
              {g.fields.map((f) => (
                <div key={f.key} className="space-y-1.5">
                  <Label>{f.label}</Label>
                  {f.type === "textarea" ? (
                    <Textarea rows={f.rows || 4} value={form[f.key] ?? ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`settings-${f.key}`} />
                  ) : f.type === "image" ? (
                    <ImageField value={form[f.key]} onChange={(v) => setForm({ ...form, [f.key]: v })} testId={`settings-${f.key}`} />
                  ) : (
                    <Input value={form[f.key] ?? ""} onChange={(e) => setForm({ ...form, [f.key]: e.target.value })} data-testid={`settings-${f.key}`} />
                  )}
                </div>
              ))}
            </div>
          </TabsContent>
        ))}
      </Tabs>
      <Button onClick={save} disabled={saving} className="mt-6 bg-orange-600 hover:bg-orange-500 rounded-full px-8 font-bold" data-testid="settings-save-btn">
        {saving ? "Menyimpan..." : "Simpan Pengaturan"}
      </Button>
    </div>
  );
};
